/** MT2: jaktradions knapp – en walkie-talkie i stället för mikrofonen. */
export function WalkieTalkieIcon({ size = 20, strokeOpacity = 1 }: { size?: number; strokeOpacity?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeOpacity={strokeOpacity} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <line x1="9" y1="1.5" x2="9" y2="6" />
      <rect x="6" y="6" width="12" height="16.5" rx="2.5" />
      <rect x="9" y="9" width="6" height="4" rx="1" />
      <line x1="9.5" y1="16" x2="14.5" y2="16" />
      <line x1="9.5" y1="19" x2="14.5" y2="19" />
    </svg>
  );
}
